import React from 'react'
import { addShift } from '../actions'
import { useDispatch } from 'react-redux';

const AddShiftButton = () => {
    const dispatch = useDispatch();
 return <button onClick={() => dispatch(addShift())}>Add Shift</button>
 }

export default AddShiftButton